import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CustomerType } from '../../../models/client-configuration';
import { ConfigService } from '../../../services/config.service';
import { SearchModel } from 'src/app/models/search-model';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CheckoutsFacade } from 'src/app/state/user/checkouts/checkouts.facade';

@Component({
  selector: 'app-user-checkouts',
  templateUrl: './user-checkouts.component.html',
  styleUrls: ['./user-checkouts.component.scss'],
})
export class UserCheckoutsComponent implements OnInit {
  @Output()
  submitted: EventEmitter<boolean> = new EventEmitter();

  searchModel: SearchModel;

  section = 'checkouts';
  userService: UserService;
  customerType: CustomerType;
  progressLoaded: boolean;

  isLoading = true;

  readonly checkouts$ = this.checkoutsFacade.checkouts$;

  constructor(
    userService: UserService,
    private configService: ConfigService,
    private router: Router,
    private apiService: ApiService,
    private checkoutsFacade: CheckoutsFacade
  ) {
    this.userService = userService;
  }

  ngOnInit() {
    this.customerType = this.configService.customerType;
    this.apiService.getPatronCheckoutsProgress(this.userService.getUserId()).subscribe((resourcesProgress) => {
      resourcesProgress.forEach((resourcesProgress) => {
        this.checkoutsFacade.checkouts.forEach((checkoutItem) => {
          if (checkoutItem.recordId === resourcesProgress.nInf && checkoutItem.percentage === undefined) {
            checkoutItem.percentage = resourcesProgress.percentage;
            this.checkoutsFacade.setCheckout(checkoutItem);
          }
        });
      });
      this.isLoading = false;
    });
  }

  explore() {
    const model = new SearchModel();
    model.explore = true;

    this.submitted.emit(true);
    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }
}
